import Loadable from "react-loadable";

const Home = Loadable({
  loader: () => import("@pages/Home"),
  loading: () => null
});

const Question = Loadable({
  loader: () => import("@pages/Question"),
  loading: () => null
});

const Quiz = Loadable({
  loader: () => import("@pages/Quiz/Quiz"),
  loading: () => null
});

const QuizReport = Loadable({
  loader: () => import("@pages/Quiz/QuizReport"),
  loading: () => null
});

const Course = Loadable({
  loader: () => import("@pages/Course/CourseCenter"),
  loading: () => null
});

const SearchResult = Loadable({
  loader: () => import("@pages/Course/SearchResult"),
  loading: () => null
});

const News = Loadable({
  loader: () => import("@pages/News/News"),
  loading: () => null
});

const InfoDetail = Loadable({
  loader: () => import("@pages/News/NewsDetail"),
  loading: () => null
});

const Mine = Loadable({
  loader: () => import("@pages/Mine/Mine"),
  loading: () => null
});

const AboutUs = Loadable({
  loader: () => import("@pages/Mine/AboutUs"),
  loading: () => null
});

const Feedback = Loadable({
  loader: () => import("@pages/Home/Feedback"),
  loading: () => null
});

const MyCollect = Loadable({
  loader: () => import("@pages/Mine/MyCollect"),
  loading: () => null
});

const MyCourse = Loadable({
  loader: () => import("@pages/Mine/MyCourse"),
  loading: () => null
});

const MyTeacher = Loadable({
  loader: () => import("@pages/Mine/MyTeacher"),
  loading: () => null
});

const Login = Loadable({
  loader: () => import("@pages/Login/Login"),
  loading: () => null
});

const Register = Loadable({
  loader: () => import("@pages/Login/Register"),
  loading: () => null
});

const Forget = Loadable({
  loader: () => import("@pages/Login/Forget"),
  loading: () => null
});

const VideoDetail = Loadable({
  loader: () => import("@pages/Course/VideoDetail"),
  loading: () => null
});

const LiveDetail = Loadable({
  loader: () => import("@pages/Course/LiveDetail"),
  loading: () => null
});

const Listening = Loadable({
  loader: () => import("@pages/Listening/listening"),
  loading: () => null
});

const LivePlay = Loadable({
  loader: () => import("@pages/Course/live/LivePlay"),
  loading: () => null
});

const TeacherHome = Loadable({
  loader: () => import("@pages/Teacher/Teacher"),
  loading: () => null
});

const TeacherDetail = Loadable({
  loader: () => import("@pages/Teacher/Detail"),
  loading: () => null
});

const Vip = Loadable({
  loader: () => import("@pages/vip/Vip"),
  loading: () => null
});

const Message = Loadable({
  loader: () => import("@pages/Home/Message"),
  loading: () => null
});

const Exam = Loadable({
  loader: () => import("@pages/Quiz/Exam"),
  loading: () => null
});

const Favorite = Loadable({
  loader: () => import("@pages/Quiz/Favorite"),
  loading: () => null
});

const Wrong = Loadable({
  loader: () => import("@pages/Quiz/Wrong"),
  loading: () => null
});

const Quiz_History = Loadable({
  loader: () => import("@pages/Quiz/History"),
  loading: () => null
});

const Share = Loadable({
  loader: () => import("@pages/Share/share"),
  loading: () => null
});

const BindPhone = Loadable({
  loader: () => import("@pages/Mine/BindPhone"),
  loading: () => null
});

const Loging = Loadable({
  loader: () => import("@pages/Mine/Loging"),
  loading: () => null
});

const LogingByPhone = Loadable({
  loader: () => import("@pages/Mine/LogingByPhone"),
  loading: () => null
});

const MyIntegral = Loadable({
  loader: () => import("@pages/Mine/MyIntegral"),
  loading: () => null
});
const InviteCode = Loadable({
  loader: () => import("@pages/Mine/InviteCode"),
  loading: () => null
});
const PersonalInfo = Loadable({
  loader: () => import("@pages/Mine/Personal"),
  loading: () => null
});

const routes = [
  { path: "/home", exact: true, component: Home }, //首页
  { path: "/register", exact: true, component: Register },
  { path: "/login", exact: true, component: Login },
  { path: "/forget", exact: true, component: Forget },
  { path: "/question", component: Question }, //题库
  { path: "/quiz", component: Quiz }, //题库
  { path: "/quizReport", component: QuizReport }, //题库
  { path: "/Exam", component: Exam }, //每日一练
  { path: "/Favorite", component: Favorite },
  { path: "/Wrong", component: Wrong },
  { path: "/History", component: Quiz_History },
  { path: "/course", component: Course }, //课程
  { path: "/videoDetail/:id/:video_id", component: VideoDetail }, //点播课程详情
  { path: "/liveDetail/:id/:video_id", component: LiveDetail }, //直播课程详情
  { path: "/videoDetail/:id", component: VideoDetail }, //点播课程详情
  { path: "/liveDetail/:id", component: LiveDetail }, //直播课程详情
  { path: "/listening/:id", component: Listening }, //直播课程详情
  { path: "/searchResult", component: SearchResult }, //搜索音频结果页
  { path: "/livePlay", component: LivePlay }, //直播间
  { path: "/teacherHome", component: TeacherHome }, //老师列表
  { path: "/teacherDetail/:id", component: TeacherDetail }, //老师详情
  { path: "/vip", component: Vip }, //Vip
  { path: "/message", component: Message }, //留言
  { path: "/news", component: News }, //资讯
  { path: "/newsDetail/:id", component: InfoDetail }, //资料

  { path: "/bindPhone", component: BindPhone }, //绑定手机
  { path: "/myTeacher", component: MyTeacher }, //我的老师
  { path: "/myCourse", component: MyCourse }, //我的课程
  { path: "/myCollect", component: MyCollect }, //我的收藏
  { path: "/inviteCode", component: InviteCode }, //我的邀请码
  { path: "/feedback", component: Feedback }, //意见反馈
  { path: "/aboutUs", component: AboutUs }, //关于我们
  { path: "/loging", component: Loging }, //正在登录
  { path: "/logingByPhone", component: LogingByPhone }, //正在登录中
  { path: "/myIntegral", component: MyIntegral }, //正在登录中
  { path: "/share", component: Share }, //关于我们
  { path: "/personal", component: PersonalInfo }, //关于我们
  {
    path: "/mine",
    component: Mine,
    routes: []
  }
];

export default routes;
